module.exports = __webpack_public_path__ + "img/ocr.8651e263.jpg";